<style lang="less" scoped>
.ui-grid {
    display: grid;
}
</style>
<script>
export default {
    props: {
        /**
         * Grid areas defined as a 2d array, which describe the layout (areas are mapped to slot names)
         * @see https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-areas
         */
        areas: {
            type: Array,
            default() {
                return [['default']];
            },
        },
        /**
         * Grid colum sizes array
         * @see Possible values: https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns#values
         */
        cols: {
            type: Array,
            default() {
                return ['1fr'];
            },
        },
        /**
         * Grid row sizes array
         * @see Possible values: https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-rows#values
         */
        rows: {
            type: Array,
            default() {
                return ['1fr'];
            },
        },
        /**
         * Grid gaps array [<row-gap>, <column-gap>]
         */
        gap: {
            type: Array,
            default() {
                return [0, 0];
            },
        },
        /**
         * Wrapper element tag name @default null
         */
        wrapTag: {
            type: String,
            default: null,
        },
    },
    computed: {
        gridStyle() {
            const { areas, cols, rows, gap } = this;
            const areasStr = areas.map(row => `"${row.join(' ')}"`).join(' ');
            return {
                'grid-template-areas': areasStr,
                'grid-template-columns': cols.join(' '),
                'grid-template-rows': rows.join(' '),
                gap: gap.join(' '),
            };
        },
        slotNames() {
            const { areas } = this;
            return [...new Set(areas.flat())].filter(val => val != '.');
        },
    },
    methods: {
        getSlotStyle(name) {
            return { 'grid-area': name, 'min-height': 0 };
        },
    },
    render(h) {
        const { wrapTag, slotNames, gridStyle, getSlotStyle, $scopedSlots } = this;
        const children = slotNames.map(name => {
            const slot = $scopedSlots[name];
            if (!slot) {
                return null;
            }
            const slotChild = slot({ style: getSlotStyle(name) });
            return wrapTag
                ? h(wrapTag, { style: getSlotStyle(name), key: name }, [slotChild])
                : slotChild;
        });
        return h('div', { class: 'ui-grid', style: gridStyle }, children);
    },
};
</script>
